<!--<div id="video-grid" class="position-relative users-count-{{activeusersVideoList.length}}">
  <div *ngFor="let user of activeusersVideoList; trackBy: trackByFn; let i = index" [attr.user-id]="user.userId" class="grid-item">
    <div class="stream-user-wrap">
      &lt;!&ndash;<h4>{{user.userId}}</h4>&ndash;&gt;
      <video playsinline [muted]="user.userId == 'self'"  #video (deferVizible)="videoStreamInit(video, user)"></video>
    </div>
  </div>
</div>-->

<app-modal-video-calls [initStartCall]="false"></app-modal-video-calls>
<ng-template [ngIf]="!callService.isCall">
  <div class="room--wrap">
    <div class="grid--wrap justify-content-center d-flex flex-wrap align-items-center">
      <div>
        <ng-template [ngIf]="callService.call" [ngIfElse]="createRoom">
          <h4>Звонок завершен</h4>
          <div class="btn-group" role="group" aria-label="Basic example">
            <button (click)="startCall('video')" class="btn btn-primary">
              <i-feather [name]="'video'"></i-feather>
              Вернуться
            </button>
            <button *ngIf="webrtcService.isSupportShareScreen" (click)="startCall('share')" class="btn btn-secondary">
              <i-feather [name]="'monitor'"></i-feather>
              Показать
            </button>
          </div>
        </ng-template>
        <ng-template #createRoom>
          <div class="mb-6">
            <button [disabled]="webrtcService.roomId" (click)="createNewRoom()" class="btn btn-primary">
              <i-feather [name]="'video'"></i-feather>
              Начать встречу
            </button>
          </div>
          <form class="mb-2 form-inline">
            <div class="form-group">
              <input
                [(ngModel)]="webrtcService.roomId"
                (ngModelChange)="cd.detectChanges()"
                type="text"
                class="form-control"
                placeholder="Ввести код встречи"
              />
            </div>
            <button [disabled]="!webrtcService.roomId" (click)="startCall()" class="btn btn-link">
              <i-feather [name]="'pluse'"></i-feather>
              Присоединиться
            </button>
          </form>
          <small *ngIf="roomCreated">
            <a [routerLink]="urlRoom" (click)="startCall()" class="text-success pointer">Ссылка на встречу
              скопирована</a>
          </small>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>